/** @format */

import { Switch } from "@headlessui/react";
import React from "react";
import { TOGGLE_THEME } from "../../stateManagement/variables";
import { UiContext } from "../../stateManagement/context/UiContext";
export default function DarkModeSwitch() {
  const { uiState, dispatch } = React.useContext(UiContext);

  return (
    <Switch
      checked={uiState.isDarkMode}
      onChange={() => dispatch({ type: TOGGLE_THEME })}
      className={`${uiState.isDarkMode ? "bg-gray-800" : "bg-gray-200"}  
            relative flex flex-shrink-0 mt-1 h-[20px] w-[60px]  border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
    >
      <span className="sr-only">Dark Mode</span>
      <span
        aria-hidden="true"
        className={`${uiState.isDarkMode ? "translate-x-8" : "translate-x-0"}
              pointer-events-none block   -mt-1 h-[25px] w-[25px] rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200`}
      >
        {!uiState.isDarkMode ? (
          <img
            src="https://img.icons8.com/carbon-copy/100/000000/sun--v1.png "
            alt="light"
          />
        ) : (
          <img
            src="https://img.icons8.com/carbon-copy/100/000000/crescent-moon.png"
            alt="dark"
          />
        )}
      </span>
    </Switch>
  );
}
